import {Component} from '@angular/core';

@Component({
    selector: 'app-authorization-container',
    templateUrl: './authorization-container.component.html',
    styleUrls: ['./authorization-container.component.scss'],
})
export class AuthorizationContainerComponent {
}
